<script setup>
import EmailingVariableForm from '@frontJs/components/forms/projectManagement/modules/EmailingVariableForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, emailingVariable, emailingVariableTypes } = defineProps({
    tenant: {
        required: true,
        type: Object,
    },
    emailingVariable: {
        required: false,
        type: Object,
    },
    emailingVariableTypes: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="emailingVariable">
            Mettre à jour la variable d'emailing #{{ emailingVariable.id }} -
            Emailings - Modules - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer une variable d'emailing - Emailings - Modules - Gestion de
            projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="emailingVariable" :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings - Mettre à jour la variable
        d'emailing #{{ emailingVariable.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings - Créer une variable d'emailing
    </PageTitle>

    <EmailingVariableForm
        :tenant="tenant"
        :emailing-variable="emailingVariable"
        :emailing-variable-types="emailingVariableTypes"
    />
</template>
